import React from 'react';
import loaderImage from '../../assets/images/stelmart logo.gif'; 

const Loader = () => (
  <div style={{
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }}>
    <img 
      src={loaderImage} 
      alt="Loading..." 
      width="150" 
      height="150" 
    />
  </div>
);

export default Loader;
